import { useBatch } from '@/contexts/BatchContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { CalendarClock, Settings as SettingsIcon } from 'lucide-react';
import ChangePasswordCard from '@/components/ChangePasswordCard';

const SettingsPage = () => {
  // We need the context but don't use currentBatch directly
  useBatch();
  const location = useLocation();
  const isRootSettings = location.pathname === '/settings';

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold tracking-tight">Settings</h1>
      </div>

      {isRootSettings ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className="hover:shadow-md transition-shadow">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle>Batches</CardTitle>
                <CalendarClock className="h-5 w-5 text-muted-foreground" />
              </CardHeader>
              <CardContent className="pt-4">
                <p className="text-muted-foreground mb-4">
                  Manage batches, set the current batch, and view data for specific academic periods.
                </p>
                <Button asChild>
                  <Link to="/settings/batches">Manage Batches</Link>
                </Button>
              </CardContent>
            </Card>

            <Card className="hover:shadow-md transition-shadow">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle>Test Settings</CardTitle>
                <SettingsIcon className="h-5 w-5 text-muted-foreground" />
              </CardHeader>
              <CardContent className="pt-4">
                <p className="text-muted-foreground mb-4">
                  Configure test-related settings including lock hours and default configurations.
                </p>
                <Button asChild>
                  <Link to="/settings/test-settings">Manage Test Settings</Link>
                </Button>
              </CardContent>
            </Card>

            <ChangePasswordCard />
          </div>
        </>
      ) : (
        <Outlet />
      )}
    </div>
  );
};

export default SettingsPage;
